<template>
  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg navbar-absolute navbar-transparent">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle d-inline">
          <button type="button" class="navbar-toggler" id="sideMenuToggler">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <router-link
          :to="{name: 'dashboard'}"
          class="navbar-brand"
          style="text-transform: capitalize; cursor: pointer;"
        >
          <img src="/images/new_logo_v2.png" width="180" />
        </router-link>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" id="settingMenuToggler">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav ml-auto">
          <!--                    <li class="search-bar input-group">-->
          <!--                        <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>-->
          <!--                            <span class="d-lg-none d-md-block">{{ __('Search') }}</span>-->
          <!--                        </button>-->
          <!--                    </li>-->

          <li style="padding: 10px 0" class="balance_item" v-if="user && user.role === 'investor'">
            <b>Cash Balance:</b>&nbsp;
            <span
              dusk="user-balance" id="cashbalance-guide"
            >{{ currency }} {{ (user.balance) ? parseFloat(user.balance).toFixed(2) : '0.00' | numberComma }}</span>
            <br class="d-block d-sm-none d-lg-none d-md-none"/>
            <router-link
              v-if="user.is_inv_fund_managed == 0"
              :to="{name: 'balance', params: {action: 'topup'}}"
              class="btn btn-sm btn-info text-white" id="topup-guide"
            >Top Up</router-link>
            <router-link
              v-if="user.is_inv_fund_managed == 0"
              :to="{name: 'balance', params: {action: 'withdraw'}}"
              class="btn btn-sm btn-secondary text-white ml-0"
              dusk="click-withdraw" id="withdraw-guide"
            >Withdraw</router-link>&nbsp;
          </li>
          <li style="padding: 10px 0" v-if="user && user.role === 'businessowner'">
            <router-link
              :to="{name: 'apply_financing'}"
              class="btn btn-sm btn-info text-white"
              dusk="click-apply-finance"
            >Apply for Financing</router-link>
          </li>
          <li class="dropdown nav-item">
            <!--                        <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-toggle="dropdown">-->
            <!--                            <div class="notification d-none d-lg-block d-xl-block"></div>-->
            <!--                            <i class="tim-icons icon-sound-wave"></i>-->
            <!--                            <p class="d-lg-none">-->
            <!--                               Notifications-->
            <!--                            </p>-->
            <!--                        </a>-->
            <ul class="dropdown-menu dropdown-menu-right dropdown-navbar">
              <!--                            <li class="nav-link">-->
              <!--                                <a href="#" class="nav-item dropdown-item">{{ __('Mike John responded to your email') }}</a>-->
              <!--                            </li>-->
            </ul>
          </li>
          <li class="dropdown nav-item">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <div class="photo">
                <img src="/white/img/anime3.png" />
              </div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none" v-if="user">
                <a href="#">{{ user.first_name }}</a>
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <!--                            <li class="nav-link" v-if="user && user.role === 'investor'">-->
              <!--                                <router-link :to="{name: 'balance', params: {action: 'withdraw'}}" class="nav-item dropdown-item">Withdraw Funds</router-link>-->
              <!--                            </li>-->
              <li class="nav-link" v-if="user && user.role === 'investor' && user.inv_plan_type ==='basic' && user.application_status === 'Approved'">
                <a
                    v-on:click.prevent="openUpgrade"
                    class="nav-item dropdown-item"
                    href="#"
                >
                  Premium
                </a>
              </li>
              <li class="nav-link">
                <router-link :to="{name: 'account_setting'}" class="nav-item dropdown-item">Settings</router-link>
              </li>
              <li class="nav-link" v-if="user && user.role === 'businessowner' && user.check_issuer_has_active_mandate == true">
                <router-link :to="{name: 'direct_debit_setting'}" class="nav-item dropdown-item">My Direct Debit</router-link>
              </li>
              <li class="nav-link" v-if="user && user.role === 'investor'">
                <a v-on:click.prevent="openRiskSettings" class="nav-item dropdown-item" href="#">Risk Profile Settings</a>
              </li>
              <li class="nav-link" v-if="user && user.role === 'investor' && user.is_inv_fund_managed == 0">
                <router-link :to="{name: 'auto_investment'}" class="nav-item dropdown-item">Auto Investment</router-link>
              </li>
              <li class="nav-link" v-if="user">
                <router-link :to="{name: 'referral'}" class="nav-item dropdown-item">My Referrals</router-link>
              </li>
              <li class="dropdown-divider"></li>
              <li class="nav-link">
                <a href="#" v-on:click="logout" class="nav-item dropdown-item">Log Out</a>
              </li>
            </ul>
          </li>
          <li class="separator d-lg-none"></li>
        </ul>
      </div>
    </div>
    <investor-premium-upgrade-modal ref="investor_premium_upgrade_modal"></investor-premium-upgrade-modal>
    <investor-risk-settings-modal ref="investor_risk_settings_modal"></investor-risk-settings-modal>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import { api, siteName } from "./../../config";
import jwtToken from "../../helpers/jwt-token";
import twoFactorToken from "../../helpers/two-factor-token";
import eventUuid from "../../helpers/event-uuid";
import InvestorPremiumUpgradeModal from "../modals/InvestorPremiumUpgradeModal";
import InvestorRiskSettingsModal from "../modals/InvestorRiskSettingsModal";
export default {
  name: "TopNav",
  components: {InvestorPremiumUpgradeModal, InvestorRiskSettingsModal},
  data() {
    return {
      user: null,
      currency: "RM",
      siteName: siteName,
      pageName: null
    };
  },

  mounted() {
    this.user = this.$store.state.auth;
    this.pageName = this.$route.name;
  },

  methods: {
    logout() {
      axios
        .post(api.logout, {
          eventUuid: eventUuid.getEventUuid()
        })
        .then(res => {
          if (res.data.success) {
            // unset user auth
            this.$store
              .dispatch("unsetAuthUser")
              .then(() => {
                // go to login page
                jwtToken.removeToken();
                twoFactorToken.removeToken();
                eventUuid.removeEventUuid();
                this.$noty.success("You are logged out");
                this.$router.push({ name: "login" });
              })
              .catch(err => {
                // error in unsetting authenticated user
              });
          } else {
            this.$noty.error(
              "Something went wrong, unable to logout, try refreshing."
            );
          }
        })
        .catch(err => {
          this.$noty.error("Something went wrong, unable to logout");
        });
    },
    openUpgrade() {
      /* $(this.$refs.investor_premium_upgrade_modal.$el).modal('show'); */ // show payment modal
      $('#investor_premium_upgrade_modal').modal('show');
    },
    openRiskSettings() {
      this.$refs.investor_risk_settings_modal.open();
    }
  }
};
</script>
